<template>
  <div v-if="tasks != null">
    <popup-add-task category="sm" ref="popupAddTask" />
    <h3>Venue Tasks</h3>
    <div class="mt-3" style="display: flex; justify-content: center; align-items: center">
      <vs-col vs-justify="center" vs-type="flex" vs-align="center" vs-w="8">
        <vs-button radius color="primary" icon="chevron_left" @click="handlePrevWeek"></vs-button>
        <span class="mx-5" style="min-width: 200px; text-align: center"
          ><h3>{{ weekTitle }}</h3></span
        >
        <vs-button radius color="primary" icon="chevron_right" @click="handleNextWeek"></vs-button>
      </vs-col>
    </div>

    <vs-row class="filter-row mt-5" vs-justify="center">
      <vs-tooltip
        :text="filterCard.tooltip"
        position="bottom"
        delay="140ms"
        v-for="filterCard in filterCardsList"
        :key="filterCard.name"
      >
        <vs-card
          class="mx-4 mb-0"
          :class="{ active: filterCard.active }"
          @click.native="handleClickCard(filterCard)"
        >
          <vs-row vs-justify="space-between">
            <span class="icon mt-5 ml-3">
              <feather-icon
                v-if="filterCard.active"
                :icon="filterCard.icon"
                svgClasses="h-7 w-7 mb-1 stroke-current text-white"
              />
              <feather-icon
                v-else
                :icon="filterCard.icon"
                svgClasses="h-7 w-7 mb-1 stroke-current text-primary"
              />
            </span>
            <span class="number mt-3 mr-5"
              ><b>{{ filterCard.numTasks }}</b>
            </span>
          </vs-row>
          <vs-row class="role mt-6">
            <h5 class="ml-3">{{ filterCard.name }}</h5>
          </vs-row>
        </vs-card>
      </vs-tooltip>
    </vs-row>

    <div class="mt-3 mx-1" style="display: flex; justify-content: space-between; align-items: center">
      <vs-button class="ml-1" @click="$refs.popupAddTask.show(moment())">Create new</vs-button>
      <div>
        <vs-row>
          <vs-input icon="search" class="mt-3 p-1" placeholder="Search" v-model="query" />
          <vs-checkbox v-model="showCompleted">Show completed</vs-checkbox>
        </vs-row>
      </div>
    </div>

    <vs-row class="mt-6 days-container" vs-justify="center">
      <vs-col
        vs-w="3"
        class="px-2"
        style="position: relative"
        v-for="dayInfo in weekList"
        :key="dayInfo.index"
      >
        <vs-card>
          <center>
            <div :class="{ bold: dayInfo.isToday }">
              <span class="day-title">{{ dayInfo.day }}</span>
              <feather-icon
                style="cursor: pointer; float: right"
                icon="PlusCircleIcon"
                svgClasses="h-5 w-5 stroke-current text-primary"
                @click="$refs.popupAddTask.show(dayInfo.date)"
              />
            </div>
          </center>
          <vs-list class="days-task-list mt-4 p-0">
            <tasks-day :tasks="tasksForVenue" :date="dayInfo.date" :showCompleted="showCompleted" />
          </vs-list>
        </vs-card>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import moment from "moment";
import _ from "lodash";
import { mapGetters } from "vuex";
import PopupAddTask from "./components/PopupAddTask.vue";
import TasksDay from "./components/TasksDay.vue";

export default {
  components: {
    PopupAddTask,
    TasksDay,
  },
  data() {
    return {
      moment,
      currentWeekDate: new Date(),
      showCompleted: false,
      query: "",
      filters: {
        vm: false,
        sm: false,
        hq: false,
        flagged: false,
        assigned: false,
      },
    };
  },
  methods: {
    async fetchTasksForWeek() {
      console.log("FETCHING for week", this.activeVenue);
      await this.$store.dispatch("venueTasks/getVenueTasks", {
        venueId: this.activeVenue.venueId,
        year: moment(this.currentWeekDate).format("yyyy"),
        week: moment(this.currentWeekDate).format("W"),
      });
    },
    handlePrevWeek() {
      this.currentWeekDate = moment(this.currentWeekDate).subtract(1, "weeks").toDate();
      this.fetchTasksForWeek();
    },
    handleNextWeek() {
      this.currentWeekDate = moment(this.currentWeekDate).add(1, "weeks").toDate();
      this.fetchTasksForWeek();
    },
    handleClickCard(card) {
      var before = this.filters[card.filter];

      if (["vm", "sm", "hq"].includes(card.filter)) {
        this.filters["vm"] = false;
        this.filters["sm"] = false;
        this.filters["hq"] = false;
      }

      this.filters[card.filter] = !before;
    },
  },
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
      tasks: "venueTasks/tasks",
      userId: "users/userId",
      roles: "venueTasks/roles",
    }),

    tasksForVenue() {
      var venueTasks = this.tasks.filter(e => e.venueIds.includes(this.activeVenue.venueId));

      return venueTasks.filter(v => {
        if (v.role === "hq" && !this.roles.some(role => role.roleId == "hq")) return false; // Can only select HQ if you have a HQ role

        if (this.filters["vm"] && v.role !== "vm") return false;
        if (this.filters["sm"] && v.role !== "sm") return false;
        if (this.filters["hq"] && v.role !== "hq") return false;
        if (this.filters["flagged"] && !v.flagged) return false;
        if (this.filters["assigned"] && v.responsibleUserId != this.userId) return false;

        if (this.query != "") {
          var qLower = this.query.toLowerCase();
          if (v.title.toLowerCase().includes(qLower)) return true;
          if (v.note.toLowerCase().includes(qLower)) return true;
          if (v.responsibleName.toLowerCase().includes(qLower)) return true;

          return false;
        }

        return true;
      });
    },

    filterCardsList() {
      var date = moment(this.currentWeekDate);
      var weekStart = date.clone().startOf("isoWeek").startOf("day");
      var weekEnd = date.clone().endOf("isoWeek").endOf("day");

      console.log(date, weekStart.toDate(), weekEnd.toDate());

      var weekTasks = this.tasksForVenue.filter(
        e =>
          moment(e.instanceDateUtcTicks).isAfter(weekStart) &&
          moment(e.instanceDateUtcTicks).isBefore(weekEnd),
      );

      weekTasks.forEach(element => {
        console.log(element);
      });

      // Filter out completed events TODO Might be prone to errors if task repeats multiple times same week
      if (!this.showCompleted) weekTasks = weekTasks.filter(e => !e.completed);

      return [
        {
          id: 0,
          permission: "",
          tooltip: "Click to filter tasks assigned to the Venue Manager role",
          name: "Venue Manager tasks",
          icon: "UsersIcon",
          numTasks: weekTasks.filter(e => e.role == "vm").length,
          filter: "vm",
          active: this.filters["vm"],
        },
        {
          id: 1,
          permission: "",
          tooltip: "Click to filter tasks assigned to the Shift Manager role",
          name: "Shift Manager tasks",
          icon: "UsersIcon",
          numTasks: weekTasks.filter(e => e.role == "sm").length,
          filter: "sm",
          active: this.filters["sm"],
        },
        {
          id: 2,
          permission: "hq",
          tooltip: "Click to filter tasks assigned to the Marketing Manager role",
          name: "Marketing tasks",
          icon: "StarIcon",
          numTasks: weekTasks.filter(e => e.role == "hq").length,
          filter: "hq",
          active: this.filters["hq"],
        },
        {
          id: 3,
          permission: "",
          tooltip: "Click to filter tasks that are marked with a flag",
          name: "Flagged tasks",
          icon: "FlagIcon",
          numTasks: weekTasks.filter(e => e.flagged).length,
          filter: "flagged",
          active: this.filters["flagged"],
        },
        {
          id: 4,
          permission: "",
          tooltip: "Click to filter tasks that are assigned to me",
          name: "Assigned to me",
          icon: "UserIcon",
          numTasks: weekTasks.filter(e => e.responsibleUserId == this.userId).length,
          filter: "assigned",
          active: this.filters["assigned"],
        },
      ].filter(e => e.permission != "hq" || this.roles.some(role => role.roleId == "hq")); // Can only view HQ if you have a HQ role;
    },

    weekTitle() {
      var date = moment(this.currentWeekDate); // TODO maybe use monday specifically?
      return `Week ${date.isoWeek()}, ${date.format("MMM YYYY")}`;
    },

    weekList() {
      var date = moment(this.currentWeekDate);

      var weekStart = date.clone().startOf("isoWeek").startOf("day");

      var days = [];
      for (var i = 0; i < 7; i++) {
        days.push({
          index: i,
          day: moment(weekStart).add(i, "days").format("dddd Do"),
          date: moment(weekStart).add(i, "days").clone(),
          isToday: moment(weekStart).add(i, "days").isSame(moment(), "day"),
        });
      }

      return days;
    },
  },
  async mounted() {
    this.$root.$on("venueTaskChanged", this.fetchTasksForWeek);

    this.$vs.loading();
    await this.$store.dispatch("venueTasks/getUserRoles", this.activeVenue.venueId);
    await this.fetchTasksForWeek();
    this.$vs.loading.close();
  },
};
</script>

<style lang="scss" scoped>
.bold {
  font-weight: bold;
}

.filter-row {
  .con-vs-card {
    cursor: pointer;
    width: 160px;
    padding: 2px;

    @media (min-width: 1562px) {
      width: 220px;

      .role > * {
        font-size: 1rem !important;
      }
    }

    .role > * {
      font-size: 0.8rem;
    }

    .number {
      color: #000;
      font-size: 24px;
    }

    &:not(.active) {
      color: white;
    }

    &.active {
      background-color: #404040;
      border: 2px solid #ffd966;
      padding: 0px;

      .role > * {
        color: #ffd966;
      }

      .number {
        color: #fff;
      }
    }
  }
}

.days-container {
  // height: 60vh;
  // overflow: auto;

  // 7 columns on large screen
  @media (min-width: 1840px) {
    flex-flow: nowrap;
  }

  .day-title {
    font-size: 14px;
  }

  .days-task-list {
    font-size: 11px;
  }

  .right-icons {
    width: 32px !important;
    // width: auto !important;
  }

  .vertical-line {
    position: absolute;
    top: 0;
    right: 0;
    width: 1px;
    height: 22vh;
    background-color: transparentize($color: #404040, $amount: 0.5);
    float: right;
  }
}
</style>